import { PayloadAction, createSlice } from "@reduxjs/toolkit"
import {
  getBoughtGenesisPreformsLeaders,
  getGenesisPreformStore
} from "../apis/preformAPI/index"
import {
  IGenesisPreformLeader,
  IGenesisPreformLeadersResponse,
  IGenesisPreformStore
} from "../apis/preformAPI/types"

interface InitialState {
  store: IGenesisPreformStore | null
  leaders: {
    leaders: IGenesisPreformLeader[]
    meInLeaders: {
      inTop100: boolean
      position: number | null
    }
  }
}

const initialState: InitialState = {
  store: null,
  leaders: {
    leaders: [],
    meInLeaders: {
      inTop100: false,
      position: null
    }
  }
}

const genesisPreformSlice = createSlice({
  name: "genesisPreforms",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addMatcher(
        getGenesisPreformStore.matchFulfilled,
        (state, action: PayloadAction<IGenesisPreformStore>) => {
          state.store = action.payload
        }
      )
      .addMatcher(
        getBoughtGenesisPreformsLeaders.matchFulfilled,
        (state, action: PayloadAction<IGenesisPreformLeadersResponse>) => {
          state.leaders = action.payload
        }
      )
  }
})

export default genesisPreformSlice
